import { NavController, NavParams, App, ModalController, ViewController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';


@Component({
  selector: 'page-rh-rhcs',
  templateUrl: 'rh-rhcs.html',
})
export class RhRHCSPage implements OnInit {

  campaign:any = null;
  answers: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) {
    this.campaign = this.navParams.get('campaign');
  }

  ngOnInit() {
        console.log(this.campaign)
        this.loadDatas();
  }

  loadDatas() {

    this.campaign.Model.Questions.forEach(currQuestion => {
        this.answers[currQuestion.id] = {
            question_id : currQuestion.id,
            option: '',
            string: '',
          };
    });

  }

  checkHandle(currQuestionId, currOption) {
    this.answers[currQuestionId].option = currOption.option; 
  }

  submitSurvey(){
    let payload = [];
    let answers = this.answers;
    let campaignId = this.campaign.id;
    let modelId = this.campaign.Model.id;
    let hasAnsweredAll = true;
    const toastController = this.toastCtrl;

       Object.keys(answers).forEach(function (key){
         if(answers[key].option == '' && answers[key].string == ''){  // Didn't answer to all question
            hasAnsweredAll = false;
         }
         payload.push({
             campaign_id : campaignId,
             model_id : modelId,
             question_id: answers[key].question_id,
             option_value: answers[key].option,
             answer_string : answers[key].string
         })
       });

       if(!hasAnsweredAll){

        let toast = toastController.create({ message: "Merci de répondre à toutes les questions", duration: 6000, position: 'top'});
        toast.present();
        return;

       }else {

        this.employeeRhProvider.rhcsSubmitAnswer(payload).subscribe((res) => {
            if(res.success){
                let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'bottom'});
                toast.present();
                this.dismiss();
            }
        });
        
    }
  }

   
// Modal ctrl
dismiss() {
    this.viewCtrl.dismiss();
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rhcs/rh-rhcs.ts